// Email validation regex pattern
// Matches standard email format: user@domain.com
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Phone number validation (basic format)
export const PHONE_REGEX = /^\+?[\d\s\-()]+$/;

// Alphanumeric with spaces only
export const ALPHANUMERIC_WITH_SPACES = /^[a-zA-Z0-9\s]+$/;

// Validation helper functions
export const isValidEmail = (email: string): boolean => {
  if (!email || email.trim() === "") return false;
  return EMAIL_REGEX.test(email.trim());
};

export const isValidPhone = (phone: string): boolean => {
  if (!phone || phone.trim() === "") return false;
  return PHONE_REGEX.test(phone.trim());
};

export const isAlphanumericWithSpaces = (text: string): boolean => {
  if (!text || text.trim() === "") return false;
  return ALPHANUMERIC_WITH_SPACES.test(text);
};
